import React from "react";
import ForgotPassCard from "../layout/ForgotPassCard";
import Navbar from "../layout/Navbar";
export default function ForgotPass() {
  return (
    <div>
      <Navbar home getStarted tools />
      <ForgotPassCard />
    </div>
  );
}
